import type { SearchParams } from '../types';

/**
 * Counts how many filter *categories* are populated, not how many individual
 * values are selected. Maximum result is 4.
 */
export function countActiveFilters(
  params: Partial<Pick<SearchParams, 'services' | 'fees' | 'clientTypes' | 'experience'>>,
): number {
  return [params.services, params.fees, params.clientTypes, params.experience].filter(
    (a): a is NonNullable<typeof a> => Array.isArray(a) && a.length > 0,
  ).length;
}
